module.exports = __webpack_public_path__ + "static/media/ppcc.050f8f37.svg";